import React from "react";
import styles from "./NyanFond.module.css";
import {resoudre} from "../reglages";
import {REGLAGES} from "./reglages";

const ETOILES = Array.from({length: 12}, (_, i) => i);

/**
 * Fond animé « Nyan Cat » (CSS pur) : arc-en-ciel, étoiles qui scintillent et chat en pixels.
 * Se place en premier enfant d'un conteneur en position relative ; il remplit ce conteneur.
 *
 * @param reglages  (facultatif) valeurs choisies dans le tableau de bord (vitesse, étoiles) ; vérifiées ici
 */
export default function NyanFond({reglages}) {
    const r = resoudre(REGLAGES, reglages);

    return (
        <div className={styles.scene} aria-hidden="true" style={{"--tempo": 1 / r.vitesse}}>
            <div className={styles.echelle}>
                <div className={styles.rainbow}><div className={styles.sprite}/></div>
                {r.etoiles && (
                    <ul className={styles.stars}>
                        {ETOILES.map(i => <li key={i}><i/></li>)}
                    </ul>
                )}
                <div className={styles.cat}>
                    <div className={styles.tail}><div className={styles.sprite}/></div>
                    <div className={styles.feet}><div className={styles.sprite}/></div>
                    <div className={styles.poptart}/>
                    <div className={styles.head}/>
                </div>
            </div>
        </div>
    );
}
